import { Language } from '../Language/Language.types';

/**
 * Actual inventory object or contract
 */
export interface InventoryEntry {
  id: string;
  createDate: Date;
  createdBy: string;
  lastUpdate?: Date;
  updatedBy?: string;
  disabled: boolean;
  name: string;
  group: InventoryGroup;
  officeId: string;
  categoryId: string;
  number: number;
  note: string;
  userChanges: InventoryUserChange[];
  currentUserId: string;
  producent: string;
  serialNumber: string;
  metaInformations: Map<string, string>;
  checks: InventoryCheck[];
  stationClass?: string;
  stationNumber?: string;
  price?: number;
  reminderMail: boolean;
  contractPartner?: string;
  date?: Date;
  toolingGroup?: ToolingGroup;
  toolType?: ToolingType;
  state?: InventoryState;
}

/**
 * State of the inventory item. Only used in contracts
 */
export enum InventoryState {
  RED = 'RED',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
}

/**
 * Used to display changes in the assigned user for an entry
 */
export interface InventoryUserChange {
  changeDate: Date;
  newUserId: string;
  oldUserId: string;
}
/**
 * Check that has been done for inventoryEntries
 */
export interface InventoryCheck {
  id: string;
  createDate: Date;
  createdBy: string;
  comment: string;
  passed: boolean;
}
/**
 * Subcategories for inventory items
 */
export interface InventoryCategory {
  id: string;
  createDate: Date;
  createdBy: string;
  lastUpdated: Date;
  updatedBy: string;
  group: InventoryGroup;
  title: string;
  translations: Map<Language, string>;
  informations: InventroyMetaInformation[];
  /**
   * The period a item should be checked. Stored in months
   */
  checkPeriod: number;
}

/**
 * Information for diffferent inventoryCategories
 */
export interface InventroyMetaInformation {
  id: string;
  title: string;
  translations: Map<Language, string>;
  type: InventoryMetaType;
}

/**
 * Possible types for meta informations
 */
export enum InventoryMetaType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
}
/**
 * Main itemGroups
 * ITEM = physical things like it-hardware or phones
 * TOOL = Measure or test equipment
 * CONTRACT = phone contracts or other supplier contracts
 */
export enum InventoryGroup {
  ITEM = 'ITEM',
  TOOL = 'TOOL',
  CONTRACT = 'CONTRACT',
}

/**
 * Defines the differend groupings for toolings
 */
export enum ToolingGroup {
  CHECK = 'CHECK',
  TESTING = 'TESTING',
  MISC = 'MISC',
}

/**
 * Defines the differend types of toolings
 */
export enum ToolingType {
  MESSCHIEBER = 'MESSCHIEBER',
  ENDMASS = 'ENDMASS',
  GRENZLEHRDORN = 'GRENZLEHRDORN',
  DREHMOMENT = 'DREHMOMENT',
  MESSUHR = 'MESSUHR',
  MESSTASTER = 'MESSTASTER',
  MIKROSKOP = 'MIKROSKOP',
  WAAGE = 'WAAGE',
  PRUFSTIFT = 'PRUFSTIFT',
  SONSTIGES = 'SONSTIGES',
}
